import React, { useState }  from "react";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { useTranslation } from "react-i18next";
import { getGlobalSettingValue, getItemOfSessionStorage } from "../../services/common/utils";
import MessageModal from "../../components/common/bottom-modal-message";
import TermsAndConditions from "../../components/cdr/TermsAndConditionsModal";
import { setAuthModalContent, setClicked2FAData, setShowAuthModal } from "../../reducer/utilitySlice";
import { useDispatch, useSelector } from "react-redux";
import SupportModal from "../more/SupportModal";
import use2FA from "../../hooks/use2FA";
import paciCheck from "./paciApiCheck";
import { setCdrCivilID, setCdrSuccessFunCall, setIsCdrVerification } from "../../reducer/cdrSlice";
import Loadingcomponent from "../../components/loader/loadingcomponent";

const VerificationPACI =({setRadioCheck, cdrResponse})=>{
    
  const [show, setShow] = useState(false);
  const [civilAddress, setCivilAddress] = useState('');
  const { t } = useTranslation();
  const [continueDisabled, setContinueDisabled] = useState(true);
  const [error, setError] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [civilId, setCivilId] = useState('');
  const [showVerificationSuccess, setShowVerificationSuccess] = useState(false);
  const dispatch = useDispatch();
  const {
    utilityData: {
      globalSetting,
      showAuthModal,
      authModalContent,
      shouldTimerStart,
      showAuthErrorModal,
      authErrorModalContent,
      showEnableMediumAuthBtn,
      showGetKuwaitAppBtn,
    },
    nojoomData: { clickedTrasferPointsCardData },
    utilityData: { clicked2FAData }
  } = useSelector((state) => state);
  const settingsArr = globalSetting
  ? globalSetting?.Globalsettings[0]?.items[0]?.metadata
  : [];
  const handleToggle = () => {
    setShow(!show);
  }
  const validateTextInput = value => {
    let validStr = value;
    if(value?.length === 0 ){
      setCivilAddress('')
    }
    if (validStr) {
      let validText = validStr.replace(
        /[`\D~!@#$%^&*()_|+\-=?;•√π÷×¶∆£¢€¥°©®™✓:'",.<> \{\}\[\]\\\/]/g,
        ''
      );
      validStr = validText.replace('‘', '');
      validStr = validText.replace('“', '');
      if (validStr) {
        if (!value.trim()) {
          setError(t('pemn'));
          return;
        }
        else {
          if (value.length < 12) {
            setContinueDisabled(true);
            setCivilAddress(validStr);
          }
          else if (value.length === 12) {
            setContinueDisabled(false);
            setCivilAddress(validStr);
            dispatch(setCdrCivilID(validStr));
          }
          else if (value.length > 12) {
            return;
          }
          setError('');
        }
      }
    }
    
  };

  const handleContinue = () =>{
    setTimeout(()=>{
      setRadioCheck(cdrResponse?.verificationconfigurations?.step_3);
    }, [1500])
    dispatch(setIsCdrVerification(false));
    setShowVerificationSuccess( true );

  }
  
  const { getMobileIdStatusCheck} = paciCheck({
    successFuncCall : handleContinue
  });

  const valUserCivilID = () => {
    if (civilAddress?.length === 0) {
      setError(t("tfr"))//t('tfr')
    }
    else if (civilAddress.length === 12) {
      setCivilId(civilAddress);
      dispatch(setIsCdrVerification(true))
      dispatch(setCdrSuccessFunCall(handleContinue))
      getMobileIdStatusCheck.refetch();
      
    } else {
      setError(t("pevcid"));// t('')
    }
  };

  // const handleCheck = (check) =>{
  //   if(check === "checked"){
  //     setTandC_Check(true);
  //   }else{
  //     setTandC_Check(false)
  //   }
  // }


    return (
        <div className='sprint17-verification-conent sprint17_white_bg'>
         <div className="sprint17-verifi-sec02">
              <div className='sprint17-form-row'>
                <div className='sprint17-ver001'>
                  <h5>{cdrResponse?.paciverificationconfigurations?.title}</h5>
                  <p>{cdrResponse?.paciverificationconfigurations?.desc} </p>
                </div>
                <div className='sprint17-mnumber'>
                  {/* <h5>66566456</h5> */}
                </div>
              </div>

              <div className='sprint17-text-field'>
                <Form.Group as={Col} md="12" controlId="validationCustom02" className='sprint16-form-control'>
                  <Form.Label>{cdrResponse?.paciverificationconfigurations?.enter_civilid_text}</Form.Label>
                  <Form.Control
                    pattern="\\d*"
                    className="form-control"
                    placeholder=""
                    maxLength={12}
                    // type="number"
                    value={civilAddress}
                    onChange={val =>{
                      validateTextInput(val.target.value)
                    }
                    }
                  />
                </Form.Group>
                {error&& <p className="text-danger mt-1 text-left mb-0 w-100  error_msg"> {error}</p>}
                {/* <div className='sprint17-resendotp'>
                  <div className='resend-btn'>
                  <a> Resend OTP </a>
                  </div>
                  <div className='resend-timer'>0.40 S</div>
                </div>    */}
              </div>

              <div className='sprint17-tandc'>
                <p style={{color: cdrResponse?.verificationconfigurations?.access_info_color ? cdrResponse?.verificationconfigurations?.access_info_color : ''}}>
                  {cdrResponse?.verificationconfigurations?.access_info_text}
                </p>
                <div>
                  <a onClick={() => setShow(!show)} handleToggle={handleToggle}>{cdrResponse?.verificationconfigurations?.tnc_link_text}</a>
                </div>
              </div>


            </div>

         <section class="fixed_footer">
          <div class="fixed_footer_container">
            <button
              class={`custom_btn btn_block sp16_custom_btn ${(getMobileIdStatusCheck?.isLoading || getMobileIdStatusCheck?.isFetching) ? " custom_btn_secondary " :" custom_btn_primary " }  ${(disabled) && 'disabled'}`}
              disabled={continueDisabled || getMobileIdStatusCheck?.isLoading || getMobileIdStatusCheck?.isFetching  } 
              onClick={valUserCivilID}
            >{getMobileIdStatusCheck?.isLoading || getMobileIdStatusCheck?.isFetching ? <Loadingcomponent/> : cdrResponse?.paciverificationconfigurations?.button_text}</button>
          </div>
        </section>

        {/* <TermsAndConditions show={show} toggleModal={handleToggle} handleCheck={handleCheck}/> */}

        {show && <SupportModal show={show} toggleModal={handleToggle} segmentId={cdrResponse?.commonconfigurations?.paci_terms_segmentid}/>}
        <MessageModal type='verification-successfull' show={showVerificationSuccess} setShowVerificationSuccess={setShowVerificationSuccess}/>
    </div>
    )
}
export default VerificationPACI;

